<template>
    <div id="catalog">
        <headers :title='titles'></headers>
        <loadingS v-if='loading'></loadingS>
        <noResouse v-if='noResouse'></noResouse>
        <div class="content">
            <div class="list-wrap"
                 v-if='dataList.length'>
                <dl class="list"
                    v-for="(item,index) in dataList">
                    <dt>{{item.name}}</dt>
                    <template v-if='item.paper.length'>
                        <dd v-for="(d,inx) in item.paper">
                            <span class="recom">
                                <span class="new"
                                      v-if="d.paper_id.is_new"></span>
                                <span class="title"
                                      :class="d.paper_id.is_new ? 'title_hasNew' : ''">{{d.title}}</span>
                                <span>({{d.num}}题)</span>
                            </span>
                            <span class="preview"
                                  @click='preview(inx,d)'>预览</span>
                            <i @click="selected(d,index,inx)"
                               :class="{'icon-fangxingkuang':!d.active,'icon-fangxing':d.active}">
                                <span v-if='d.active'>移除</span>
                                <span v-else>加入</span>
                            </i>
                        </dd>
                    </template>
                    <dd v-else>
                        暂无推荐试卷
                    </dd>
                </dl>
                <div class="self">
                    <span>以上没有合适的? 自己选题</span>
                    <span @click='self'>自选</span>
                    <i @click='self'></i>
                </div>
            </div>
        </div>
        <div class="foot"
             v-if='!loading'>
            <div class="bottom_btn">
                <a :class="[num > 0 ?'bth_a1':'bth_a2']">
                    <span @click='allpreview'
                          v-if='num'>已选{{num}}题, 点击预览</span>
                    <span v-else='num'>已选{{0}}题, 点击预览</span>
                </a>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue';
import loadingS from 'COMPONENTS/base/tealoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue'

export default {
    data () {
        return {
            sid: this.$route.params.sid,
            type: this.$route.params.type,  //2同步习题 3单元复习
            closeFlag: true,
            dataList: [],
            titles: '',
            qid: [],  //所选的列表的id
            loading: true,  //加载图
            noResouse: false,  //没有资源
            num: 0
        }
    },
    created () {
        setTimeout(() => {
            //console.log(this.cid)
        }, 1000)
        let math_send_ok = localStorage.getItem('math_send_ok');
        if (math_send_ok == 1) {
            this.$router.go(-1);
            return false;
        }
        this.titles = this.type == 2 ? '同步习题' : '单元复习'
        // let cid ='2228,2229'  //需要列表也得章节id  写死了

        this.$http.post(API_URL_TASK_API + '/maths/send/general/catalog/paper', {
            cid: this.cid,
            'sid': this.sid
        }).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                if (res.data.length) {
                    this.loading = false
                    this.dataList = this.dataList.concat(res.data);
                    this.dataList.forEach(function (item) {
                        item.paper.forEach(d => {
                            d.active = false;
                        })
                    });
                    this.$nextTick(function () {
                        MathJax.Hub.Typeset(document.body);
                    })
                } else {
                    this.noResouse = true
                }
            } else {
                this.noResouse = true
            }
        })
    },
    components: {
        headers,
        loadingS,
        noResouse
    },

    computed: {
        cid () {
            return this.$store.state.math.chapterid.join(',')
        },
    },
    destroyed () {

    },
    methods: {
        goBack () {
            this.$router.go(-1)
        },
        close () {
            this.closeFlag = false;
        },
        send () {
            //console.log('发布')
        },
        preview (inx, d) {
            // 1  全部的id
            // typeOf  全部的id  //2同步习题 3单元复习
            let _pid = this.sid == 21 ? d.paper_id.paper_id : d.paper_id;
            let is_new = this.sid == 21 ? d.paper_id.is_new : 0;
            this.$router.push('/sx/testPaper/preview/' + this.sid + '/' + 0 + '?id=' + _pid + '&title=' + d.title + '&typeOf=' + this.type + '&is_new=' + is_new)
        },
        allpreview () {
            // 1  全部的id
            // typeOf  全部的id  //2同步习题 3单元复习
            this.$store.commit('setscreenid', this.qid)
            this.$router.push('/sx/testPaper/preview/' + this.sid + '/' + 1 + '?typeOf=' + this.type)
        },
        self () {
            this.$router.push('/sx/testPaper/taskselect/' + this.sid + '/' + this.type)
        },
        selected (d, index, inx) {
            if (!d.active) {
                this.num += d.num
                if (this.sid == '21') {
                    this.qid.push(d.paper_id.paper_id)
                } else {
                    this.qid.push(d.paper_id)
                }
            } else {
                this.num -= d.num
                this.qid.forEach((m, n) => {
                    if (this.sid == '21') {
                        if (m == d.paper_id.paper_id) {
                            this.qid.splice(n, 1)
                        }
                    } else {
                        if (m == d.paper_id) {
                            this.qid.splice(n, 1)
                        }
                    }
                })
            }
            d.active = !d.active;
            this.dataList[index].paper.splice(inx, 1, d);
        }
    }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

#catalog {
    min-height: 100vh;
    .content {
        padding-bottom: 2.8rem;
        .prompting {
            position: relative;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            font-size: 24px / $ppr;
            color: #5e89ef;
            text-align: center;
            background-color: #fff;
            i {
                display: block;
                position: absolute;
                top: 36px / $ppr;
                right: 40px / $ppr;
                color: #cbcbcb;
            }
        }

        .list-wrap {
            .list {
                margin-top: 24px / $ppr;
                background-color: #fff;
                dt {
                    padding: 0 24px / $ppr;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;
                    font-size: 30px / $ppr;
                    font-weight: bold;
                    color: #333;
                }
                dd {
                    position: relative;
                    padding-left: 24px / $ppr;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;
                    font-size: 30px / $ppr;
                    color: #333;
                    border-top: 1px / $ppr solid #e8e8e8;
                    i {
                        display: inline-block;
                        position: absolute;
                        top: 24px / $ppr;
                        font-size: 40px / $ppr;
                        height: 48px / $ppr;
                        box-sizing: border-box;
                        &.icon-fangxingkuang {
                            top: 24px / $ppr;
                            text-align: center;
                            line-height: 48px / $ppr;
                            width: 122px / $ppr;
                            right: 24px / $ppr;
                            border: 1px / $ppr solid #5e89ef;
                            color: #5e89ef;
                            border-radius: 50px / $ppr;
                            font-size: 24px / $ppr;
                        }
                        &.icon-fangxing {
                            top: 24px / $ppr;
                            text-align: center;
                            line-height: 48px / $ppr;
                            width: 122px / $ppr;
                            right: 24px / $ppr;
                            border: 1px / $ppr solid #ff6600;
                            color: #ff6600;
                            border-radius: 50px / $ppr;
                            font-size: 24px / $ppr;
                        }
                    }
                    .recom {
                        min-width: 460px / $ppr;
                        margin-top: -2px / $ppr;
                        span {
                            max-width: 205px / $ppr;
                            vertical-align: middle;
                        }
                        .new {
                            display: inline-block;
                            width: 47px / $ppr;
                            height: 32px / $ppr;
                            background: url("./img/icon4.png") 0 0 no-repeat;
                            background-size: 100% 100%;
                        }
                        .title {
                            max-width: 336px / $ppr;
                            vertical-align: middle;
                            @include ellipsis;
                            &.title_hasNew {
                                max-width: 300px / $ppr;
                            }
                        }
                    }
                    span {
                        display: inline-block;
                        // @include ellipsis;
                        &.already {
                            position: absolute;
                            right: 24%;
                        }
                        &.preview {
                            color: #5e89ef;
                            position: absolute;
                            right: 24%;
                        }
                    }
                }
            }
            .list:first-child {
                margin-top: 0;
            }
        }
    }
    .self {
        margin-top: 30px / $ppr;
        background-color: #fff;
        line-height: 100px / $ppr;
        padding-left: 24px / $ppr;
        position: relative;
        font-size: 30px / $ppr;
        span {
            display: inline-block;
            color: #555;
        }
        span:nth-of-type(2) {
            color: #5e89ef;
            position: absolute;
            right: 68px / $ppr;
        }
        i {
            display: inline-block;
            width: 20px / $ppr;
            height: 30px / $ppr;
            position: absolute;
            right: 24px / $ppr;
            top: 35px / $ppr;
            background: url("./img/enter.png");
            background-size: contain;
            background-repeat: no-repeat;
        }
    }
    .foot {
        position: fixed;
        bottom: 0;
        width: 100%;

        .bottom_btn {
            a {
                color: #999999;
                display: inline-block;
                height: 97px / $ppr;
                line-height: 97px / $ppr;
                width: 100%;
                text-align: center;
                font-size: $lg;
                float: left;
                box-sizing: border-box;
                &.bth_a1 {
                    background-color: #5e89ef;
                    color: #fff;
                }
                &.bth_a2 {
                    background-color: #cccccc;
                    color: #999999;
                }
                span {
                    width: 100vw;
                    display: inline-block;
                }
            }
        }
    }
}
</style>
